import { Component } from "interfaces/component";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";
import { makeQueryString } from "core/makeQueryString";

interface LazyFetchResponse {
  count?: number;
  results?: Component[];
}

interface LazyFetchComponents {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetComponents = ({
  page = 1,
  pageSize = 15000
}: {
  page?: number;
  pageSize?: number;
}): {
  loading: boolean;
  error: boolean;
  fetchComponents: (
    queryParams?: Record<string, any>
  ) => Promise<LazyFetchResponse>;
} => {
  const { loading, error, fetchCallback }: LazyFetchComponents = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchComponents: (queryParams?: Record<string, any>) => {
      const params = { page, size: pageSize, ...queryParams };
      const queryString = makeQueryString(params);

      return fetchCallback(`components${queryString}`);
    }
  };
};
